import type { CalendarEvent } from '../../../types';
import type { BorderStyle, EventVariant } from '../types';

// Drives visual variant from the new block_state contract:
//   reality === 'suggested'                          → actionable + dashed
//   reality === 'cancelled' | 'rescheduling'         → actionable + solid
//   reality === 'block'                              → block
//   encounter.status === 'completed'                 → standard (post-visit)
//   default                                          → standard
export const getEventVariant = (
  event: CalendarEvent,
): {
  variant: EventVariant;
  borderStyle?: BorderStyle;
} => {
  const resource = event.resource;
  const reality = resource.block_state?.reality;

  if ((resource.encounter as { status?: string } | null)?.status === 'completed') {
    return { variant: 'standard' };
  }
  if (reality === 'suggested') {
    return { variant: 'actionable', borderStyle: 'dashed' };
  }
  if (reality === 'cancelled' || reality === 'rescheduling') {
    return { variant: 'actionable', borderStyle: 'solid' };
  }
  if (reality === 'block') {
    return { variant: 'block' };
  }
  return { variant: 'standard' };
};
